import i18n from '../i18n';
import Conversation from '../models/Conversation';
import { STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED, STAY_REQUEST_STATUS_PAST_DATES_DECLINE } from '@homeexchange/conversations';
export var getConversationStatus = function (stayRequestStatus, conversation) {
    if (conversation) {
        if (conversation.get('status') === Conversation.STATUS_DELETED) {
            return {
                slug: 'deleted',
                label: i18n.t('exchange:status.deleted')
            };
        }
        else if ([
            Conversation.STATUS_RECEIVED,
            Conversation.STATUS_INITIALIZED,
            Conversation.STATUS_RECEIVED_UNREAD,
            Conversation.STATUS_INITIALIZED_W_RESPONSE,
            Conversation.STATUS_RECEIVED_W_RESPONSE,
            Conversation.STATUS_RECEIVED_W_RESPONSE_AND_UNREAD
        ].includes(conversation.get('status')) &&
            [STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED, STAY_REQUEST_STATUS_PAST_DATES_DECLINE].includes(stayRequestStatus)) {
            return {
                slug: stayRequestStatus === null || stayRequestStatus === void 0 ? void 0 : stayRequestStatus.toLowerCase(),
                label: i18n.t("exchange:status.automatically_declined")
            };
        }
        else {
            return conversation.getExchangeStatus();
        }
    }
    return {};
};
